module.exports = __webpack_public_path__ + "img/01-dark.1d884d9a.png";